var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import LoaderCard from '../loader-card/LoaderCard';
import { UserSubjectStatusEnum } from '@/models/UserSubject';
import ProgressSelect from '@/components/progress-select/ProgressSelect';
let ProgressDialog = class ProgressDialog extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #region @Props
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        // For this to work for some reason..
        this.status = UserSubjectStatusEnum.HIGHLIGHTED;
        this.progress = '00000';
        // #endregion
        // #region Async methods
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.isLoading = false;
    }
    // #endregion
    // #region Class methods
    closeDialog() {
        this.$emit('input', false);
    }
    onProgressUpdated(progress) {
        this.progress = progress;
    }
    onConfirm() {
        this.$emit('change', this.progress);
        this.closeDialog();
    }
};
ProgressDialog = __decorate([
    Component({
        components: {
            LoaderCard,
            ProgressSelect,
        },
    })
], ProgressDialog);
export default ProgressDialog;
